export const translationConfig = {
  common: [],
  feature: 'Feature.Profile'
};

export default translationConfig;
